import React from 'react';
import Recommendation from './recommendation';
import { recShape } from './recommendation_mapper';

const FormatRecommendation = ({ rec }) => {
  const headline = 'Drive more traffic with formats your audience loves';
  const strongFormat = <strong>{rec.primaryItemName}</strong>;

  return (
    <Recommendation headline={headline} rec={rec}>
      {'Your '}
      {strongFormat}
      {' are generating above-average ' }
      {rec.metric}
      {'. Update your content plan to create more '}
      {strongFormat}
      {'.'}
    </Recommendation>
  );
};

export default FormatRecommendation;

FormatRecommendation.propTypes = {
  rec: recShape.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/format_recommendation.jsx